// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { ChevronLeft } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconChevronLeft(props: any) {
    return <IconBase icon={ChevronLeft} {...props} />
  }

  export default IconChevronLeft
  